import { render, staticRenderFns } from "./FilterExchange.vue?vue&type=template&id=a3f6b70e"
import script from "./FilterExchange.vue?vue&type=script&lang=js"
export * from "./FilterExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FilterExchange.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DropdownList: require('/vercel/path0/components/DropdownList.vue').default})
